// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"72":"Cart","187":"NotFound","591":"FullPhone"}[chunkId] + "." + {"72":"85c5986c","187":"7071f1a7","591":"8cdde67f"}[chunkId] + ".chunk.js";
};